import { jsonify, sanitize } from "../TapiocaUtils";
export default class Admin2Client {
  constructor(raw) {
    this.raw = raw;
  }
  adminPermissions(userId) {
    const url = `/users/${userId}/admin_permissions`;
    return this.raw.get(url);
  }
  archiveOrganizationProjects(organizationId, body) {
    const url = `/organizations/${organizationId}/projects_/archive`;
    return this.raw.post(url, jsonify(body));
  }
  batchCreateOrganizationGroupUsers(organizationId, groupId, body) {
    const url = `/organizations/${organizationId}/groups/${groupId}/users_/create`;
    return this.raw.post(url, jsonify(body));
  }
  batchDeleteOrganizationGroupUsers(organizationId, groupId, body) {
    const url = `/organizations/${organizationId}/groups/${groupId}/users_/delete`;
    return this.raw.post(url, jsonify(body));
  }
  createOrganization(body) {
    const url = "/organizations";
    return this.raw.post(url, jsonify(body));
  }
  createOrganizationGroup(organizationId, body) {
    const url = `/organizations/${organizationId}/groups`;
    return this.raw.post(url, jsonify(body));
  }
  createOrganizationGroupUser(organizationId, groupId, userId) {
    const url = `/organizations/${organizationId}/groups/${groupId}/users/${userId}`;
    return this.raw.post(url, {});
  }
  createOrganizationProject(organizationId, body) {
    const url = `/organizations/${organizationId}/projects`;
    return this.raw.post(url, jsonify(body));
  }
  createOrganizationSsoSettings(organizationId, body) {
    const url = `/organizations/${organizationId}/sso_settings`;
    return this.raw.post(url, jsonify(body));
  }
  createPlangridAdmin(userId) {
    const url = `/users/${userId}/plangrid_admin`;
    return this.raw.post(url, {});
  }
  createSsoIdentityProvider(body) {
    const url = "/identity_providers";
    return this.raw.post(url, jsonify(body));
  }
  createSsoMetadata(organizationId, body) {
    const url = `/organizations/${organizationId}/sso_metadata_xml`;
    return this.raw.post(url, jsonify(body));
  }
  deleteOrganizationGroup(organizationId, groupId) {
    const url = `/organizations/${organizationId}/groups/${groupId}`;
    return this.raw.delete(url);
  }
  deleteOrganizationGroupUser(organizationId, groupId, userId) {
    const url = `/organizations/${organizationId}/groups/${groupId}/users/${userId}`;
    return this.raw.delete(url);
  }
  deleteOrganizationOrder(organizationId, params) {
    const url = {
      url: `/organizations/${organizationId}/orders`,
      params: sanitize(params || {}),
    };
    return this.raw.delete(url);
  }
  deleteOrganizationProject(projectId) {
    const url = `/projects/${projectId}/organization`;
    return this.raw.delete(url);
  }
  deleteOrganizationSsoSettings(organizationId) {
    const url = `/organizations/${organizationId}/sso_settings`;
    return this.raw.delete(url);
  }
  deletePlangridAdmin(userId) {
    const url = `/users/${userId}/plangrid_admin`;
    return this.raw.delete(url);
  }
  deleteUserProjects(userId, body) {
    const url = `/users/${userId}/projects_/delete`;
    return this.raw.post(url, jsonify(body));
  }
  disableOrganizationFeatureFlag(organizationId, featureFlagName) {
    const url = `/organizations/${organizationId}/feature_flags/${featureFlagName}`;
    return this.raw.delete(url);
  }
  editAdminPermissions(userId, body) {
    const url = `/users/${userId}/admin_permissions`;
    return this.raw.put(url, jsonify(body));
  }
  enableOrganizationFeatureFlag(organizationId, featureFlagName) {
    const url = `/organizations/${organizationId}/feature_flags/${featureFlagName}`;
    return this.raw.post(url, {});
  }
  expireBulkUserSessions(body) {
    const url = "/bulk/user/sessions/expire";
    return this.raw.post(url, jsonify(body));
  }
  expireUserSessions(userId) {
    const url = `/user/${userId}/sessions/expire`;
    return this.raw.post(url, {});
  }
  explicitDeletionDecider(body) {
    const url = "/delete_entity";
    return this.raw.post(url, jsonify(body));
  }
  filterOrganizationProjects(body, params) {
    const url = {
      url: "/organizations/projects/filter",
      params: sanitize(params || {}),
    };
    return this.raw.post(url, jsonify(body));
  }
  filterSalesforceOpportunities(body) {
    const url = "/salesforce_opportunities/filter";
    return this.raw.post(url, jsonify(body));
  }
  filterUsersEntitlement(entitlementType, body) {
    const url = `/users/entitlements/${entitlementType}/filter`;
    return this.raw.post(url, jsonify(body));
  }
  getAccountSalesforceOpportunities(accountId, params) {
    const url = {
      url: `/salesforce_accounts/${accountId}/salesforce_opportunities`,
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  getAllOrganizationProjects(
    organizationId,
    params,
    options = { getAll: false }
  ) {
    const url = `/organizations/${organizationId}/projects_/all`;
    if (options.getAll) {
      return this.raw.getAll(url, sanitize(params || {}, {}));
    }
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
  getEntitlementForUser(userId, entitlementType, params) {
    const url = {
      url: `/users/${userId}/entitlements/${entitlementType}`,
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  getEntitlementsForUser(userId, params, options = { getAll: false }) {
    const url = `/users/${userId}/entitlements`;
    if (options.getAll) {
      return this.raw.getAll(url, sanitize(params || {}, {}));
    }
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
  getOrganization(organizationId, body) {
    const url = `/organizations/${organizationId}`;
    return this.raw.patch(url, jsonify(body));
  }
  getOrganizationAdmins(organizationId, params, options = { getAll: false }) {
    const url = `/organizations/${organizationId}/admins`;
    if (options.getAll) {
      return this.raw.getAll(url, sanitize(params || {}, {}));
    }
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
  getOrganizationEntitlement(organizationId, entitlementType) {
    const url = `/organizations/${organizationId}/entitlements/${entitlementType}`;
    return this.raw.get(url);
  }
  getOrganizationEntitlements(
    organizationId,
    params,
    options = { getAll: false }
  ) {
    const url = `/organizations/${organizationId}/entitlements`;
    if (options.getAll) {
      return this.raw.getAll(url, sanitize(params || {}, {}));
    }
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
  getOrganizationFeatureFlags(organizationId) {
    const url = `/organizations/${organizationId}/feature_flags`;
    return this.raw.get(url);
  }
  getOrganizationGroups(organizationId, params, options = { getAll: false }) {
    const url = `/organizations/${organizationId}/groups`;
    if (options.getAll) {
      return this.raw.getAll(url, sanitize(params || {}, {}));
    }
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
  getOrganizationGroupUsers(
    organizationId,
    groupId,
    params,
    options = { getAll: false }
  ) {
    const url = `/organizations/${organizationId}/groups/${groupId}/users`;
    if (options.getAll) {
      return this.raw.getAll(url, sanitize(params || {}, {}));
    }
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
  getOrganizationOrders(organizationId) {
    const url = `/organizations/${organizationId}/orders`;
    return this.raw.get(url);
  }
  getOrganizationProject(organizationId, projectId) {
    const url = `/organizations/${organizationId}/projects/${projectId}`;
    return this.raw.get(url);
  }
  getOrganizationProjectAuditLog(
    projectId,
    params,
    options = { getAll: false }
  ) {
    const url = `/projects/${projectId}/organization_audit_log`;
    if (options.getAll) {
      return this.raw.getAll(url, sanitize(params || {}, {}));
    }
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
  getOrganizationProjectRoles(
    organizationId,
    projectId,
    params,
    options = { getAll: false }
  ) {
    const url = `/organizations/${organizationId}/projects/${projectId}/roles`;
    if (options.getAll) {
      return this.raw.getAll(url, sanitize(params || {}, {}));
    }
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
  getOrganizationProjects(organizationId, params, options = { getAll: false }) {
    const url = `/organizations/${organizationId}/projects`;
    if (options.getAll) {
      return this.raw.getAll(url, sanitize(params || {}, {}));
    }
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
  getOrganizationProjectUsers(
    organizationId,
    projectId,
    params,
    options = { getAll: false }
  ) {
    const url = `/organizations/${organizationId}/projects/${projectId}/users`;
    if (options.getAll) {
      return this.raw.getAll(url, sanitize(params || {}, {}));
    }
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
  getOrganizationSsoSettings(organizationId) {
    const url = `/organizations/${organizationId}/sso_settings`;
    return this.raw.get(url);
  }
  getOrganizationSsoSettingsByEntityId(params) {
    const url = {
      url: "/organizations/sso_settings",
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  getOrganizationUsers(organizationId, params, options = { getAll: false }) {
    const url = `/organizations/${organizationId}/users`;
    if (options.getAll) {
      return this.raw.getAll(url, sanitize(params || {}, {}));
    }
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
  getPlangridAdmin(userId) {
    const url = `/users/${userId}/plangrid_admin`;
    return this.raw.get(url);
  }
  getPlangridAdmins() {
    const url = "/plangrid_admins";
    return this.raw.get(url);
  }
  getProjectEntitlement(projectId, entitlementType) {
    const url = `/projects/${projectId}/entitlements/${entitlementType}`;
    return this.raw.get(url);
  }
  getProjectEntitlements(projectId, params) {
    const url = {
      url: `/projects/${projectId}/entitlements`,
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  getProjectOrganization(projectId, params) {
    const url = {
      url: `/projects/${projectId}/organization`,
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  getSalesforceAccount(accountId) {
    const url = `/salesforce_accounts/${accountId}`;
    return this.raw.get(url);
  }
  getSalesforceAccountOrganizations(accountId) {
    const url = `/salesforce_accounts/${accountId}/organizations`;
    return this.raw.get(url);
  }
  getSalesforceAccounts(params) {
    const url = {
      url: "/salesforce_accounts",
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  getSalesforceOpportunities(params) {
    const url = {
      url: "/salesforce_opportunities",
      params: sanitize(params || {}, { "id[]": "multi" }),
    };
    return this.raw.get(url);
  }
  getUserEntitlement(entitlementType, params) {
    const url = {
      url: `/me/entitlements/${entitlementType}`,
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  getUserEntitlements(params, options = { getAll: false }) {
    const url = "/me/entitlements";
    if (options.getAll) {
      return this.raw.getAll(url, sanitize(params || {}, {}));
    }
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
  getUserSsoSettings(params) {
    const url = {
      url: "/users/sso_settings",
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  handleErasureRequest(body) {
    const url = "/erasure";
    return this.raw.post(url, jsonify(body));
  }
  /**
   * Fetch a receipt item by its uid
   * :param receipt_item_uid:
   * :return: ReceiptItem
   */
  handleGetReceiptItem(receiptItemUid) {
    const url = `/erasure/${receiptItemUid}`;
    return this.raw.get(url);
  }
  listOrganizations(params) {
    const url = {
      url: "/organizations",
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  listUserProjects(userId, params, options = { getAll: false }) {
    const url = `/user/${userId}/projects`;
    if (options.getAll) {
      return this.raw.getAll(url, sanitize(params || {}, {}));
    }
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
  /**
   * Add users to a project
   * :reqjsonobj array emails: The emails of users to be added
   * :reqjsonobj string role uid: The role if we want new proj users to have
   * :resjson array project_users: The users successfully added to the project
   * :resjson object results: The results per email of the request
   * :resjson array succeeded_emails: Emails of successfully created users
   * :resjson array failed_groups: Groups of failed emails and the failure reason
   * :resjsonarray string reason: reason for post failure
   * :resjsonarray array emails: corresponding emails
   * :statuscode 200: Will be passed back if the response succeeds, even if
   * no project users were added
   * :statuscode 403: if the user does not have authorization to access the org
   * :statuscode 404: if the project specified in the url does not belong to the org
   */
  organizationProjectUsersCreate(organizationId, projectId, body) {
    const url = `/organizations/${organizationId}/projects/${projectId}/users_/batch`;
    return this.raw.post(url, jsonify(body));
  }
  organizationProjectUsersDelete(organizationId, projectId, body) {
    const url = `/organizations/${organizationId}/projects/${projectId}/users_/delete`;
    return this.raw.post(url, jsonify(body));
  }
  organizationProjectUsersUpdate(organizationId, projectId, body) {
    const url = `/organizations/${organizationId}/projects/${projectId}/users_/batch`;
    return this.raw.patch(url, jsonify(body));
  }
  organizationUserBulkUpdate(organizationId, body) {
    const url = `/organizations/${organizationId}/users_/batch`;
    return this.raw.patch(url, jsonify(body));
  }
  organizationUserDataOwnershipBulkUpdate(organizationId, body) {
    const url = `/organizations/${organizationId}/data_ownership_update`;
    return this.raw.post(url, jsonify(body));
  }
  organizationUserDataOwnershipInvitationAccept(organizationId, userId) {
    const url = `/organizations/${organizationId}/users/${userId}/data_ownership_invitation`;
    return this.raw.put(url, {});
  }
  organizationUserDataOwnershipInvitationDecline(organizationId, userId) {
    const url = `/organizations/${organizationId}/users/${userId}/data_ownership_invitation`;
    return this.raw.delete(url);
  }
  resetOrganizationUsersPassword(organizationId, body) {
    const url = `/organization/${organizationId}/users/password/reset`;
    return this.raw.post(url, jsonify(body));
  }
  restoreOrganizationProjects(organizationId, body) {
    const url = `/organizations/${organizationId}/projects_/restore`;
    return this.raw.put(url, jsonify(body));
  }
  ssoIdentityProviders() {
    const url = "/identity_providers";
    return this.raw.get(url);
  }
  ssoMetadata(organizationId) {
    const url = `/organizations/${organizationId}/sso_metadata_xml`;
    return this.raw.get(url);
  }
  transferOrganizationProjects(organizationId, body) {
    const url = `/organizations/${organizationId}/projects_/transfer`;
    return this.raw.post(url, jsonify(body));
  }
  transferOrganizationUserNotes(fromOrganizationUid, toOrganizationUid) {
    const url = `/organizations/${fromOrganizationUid}/notes_/transfer/${toOrganizationUid}`;
    return this.raw.post(url, {});
  }
  updateContract(organizationId, contractId, body) {
    const url = `/organizations/${organizationId}/contracts/${contractId}`;
    return this.raw.patch(url, jsonify(body));
  }
  updateOrganizationFeatureFlags(organizationId, body) {
    const url = `/organizations/${organizationId}/feature_flags`;
    return this.raw.patch(url, jsonify(body));
  }
  updateOrganizationGroup(organizationId, groupId, body) {
    const url = `/organizations/${organizationId}/groups/${groupId}`;
    return this.raw.patch(url, jsonify(body));
  }
  updateOrganizationProjectProfile(organizationId, projectId, body) {
    const url = `/organizations/${organizationId}/projects/${projectId}/profile`;
    return this.raw.put(url, jsonify(body));
  }
  updateOrganizationSsoSettings(organizationId, body) {
    const url = `/organizations/${organizationId}/sso_settings`;
    return this.raw.patch(url, jsonify(body));
  }
  updateOrganizationUser(organizationId, userId, body) {
    const url = `/organizations/${organizationId}/users/${userId}`;
    return this.raw.patch(url, jsonify(body));
  }
  updateSsoMetadata(organizationId, body) {
    const url = `/organizations/${organizationId}/sso_metadata_xml`;
    return this.raw.patch(url, jsonify(body));
  }
}
